import { render, staticRenderFns } from "./CustomersNotesTemplate.vue?vue&type=template&id=a641321e"
import script from "./CustomersNotesTemplate.vue?vue&type=script&lang=ts"
export * from "./CustomersNotesTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports